import whatIsCryptocurrencyTradingContent from './content/what-is-cryptocurrency-trading.json';

const whatIsCryptocurrencyTradingMock = {
    layoutType: 2,
    data: {
        name: 'what-is-cryptocurrency-trading',
        layoutType: 2,
        areasList: [
            {
                id: 'what-is-cryptocurrency-trading-page-area',
                name: 'Content',
                componentName: 'Comp:WhatIsCryptocurrencyTradingPage',
                content: JSON.stringify(whatIsCryptocurrencyTradingContent),
            },
        ],
    },
};

export default whatIsCryptocurrencyTradingMock;
